import React from 'react';
import { useSelector } from 'react-redux';
import TextTruncate from 'react-text-truncate';

// Helpers
import WorkspaceRecentUpdatesHelper from 'Shared/model_helpers/WorkspaceRecentUpdates.helper';
import WorkspaceItemCommentHelper from 'Shared/model_helpers/WorkspaceItemComment.helper';

// Selectors
import * as workspaceItemCommentsSelectors from 'Shared/selectors/WorkspaceItemComments.selectors';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './NotificationComment.scss';

type Props = {
  notification;
};

const NotificationComment = ({ notification }: Props) => {
  const commentUuid = WorkspaceRecentUpdatesHelper.getWorkspaceCommentUuid(notification);
  const comment = useSelector(state => workspaceItemCommentsSelectors.getCommentByCommentUuid(state, { commentUuid }));
  const bodyRawText = WorkspaceItemCommentHelper.getBodyRawText(comment);

  const baseClassName = 'NotificationComment';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__icon`}>
        <WpIcon name="comment" />
      </div>
      <div className={`${baseClassName}__body`}>
        <TextTruncate line={2} truncateText="…" text={bodyRawText} />
      </div>
    </div>
  );
};

export default NotificationComment;
